import { jsxs as p, Fragment as f, jsx as r } from "react/jsx-runtime";
import { useState as x, useEffect as a } from "react";
import { useTranslation as w } from "react-i18next";
import v from "markdown-to-jsx";
import { ExpandMore as y } from "@mui/icons-material";
import i from "@mui/material/Box";
import A from "@mui/material/Divider";
import g from "@mui/material/Typography";
import { makeStyles as F } from "tss-react/mui";
import S from "@lumirental/lumi-web-shared/lib/constants/app/LIST_THRESHOLD";
import T from "../../../../common/Button/Button.js";
import k from "./FAQList.style.js";
import L from "../../components/Accordion/Accordion.js";
const Q = F()(k), _ = ({ listData: o }) => {
  const [e, c] = x([]), { classes: s } = Q(), { t: h } = w();
  let t = !1;
  o && (t = (o == null ? void 0 : o.length) !== (e == null ? void 0 : e.length)), a(() => {
    o && c(o.slice(0, S.FAQ));
  }, [o]);
  const u = () => {
    c(o);
  };
  return /* @__PURE__ */ p(f, { children: [
    e && e.map((n) => {
      const l = (n == null ? void 0 : n.question) ?? "", d = (n == null ? void 0 : n.answer) ?? "", m = `${l}_${d}`;
      return /* @__PURE__ */ p(i, { className: s.wrapper, children: [
        /* @__PURE__ */ r(L, { id: m, title: l, children: /* @__PURE__ */ r(i, { pb: { xs: 3 }, children: /* @__PURE__ */ r(
          g,
          {
            variant: "subheading",
            className: s.accordianContent,
            children: /* @__PURE__ */ r(v, { children: d })
          }
        ) }) }),
        /* @__PURE__ */ r(
          A,
          {
            classes: {
              root: s.divider
            }
          }
        )
      ] }, m);
    }),
    t && /* @__PURE__ */ r(i, { py: { xs: 2 }, children: /* @__PURE__ */ r(
      T,
      {
        variation: "text",
        dataTestid: "viewAllQuestion",
        endIcon: /* @__PURE__ */ r(y, { className: s.expandIcon }),
        onClick: u,
        children: h("view_all_questions")
      }
    ) })
  ] });
}, G = _;
export {
  G as default
};
